import React, { useState } from 'react';
import HeaderDropdown, { DropdownCard, DropdownCardsGrid } from './HeaderDropdown';

const LoansDropdown = ({ isOpen, onMouseEnter, onMouseLeave }) => {
    const [activeTab, setActiveTab] = useState('housing');

    const categories = [
        { id: 'housing', label: 'Housing Finance' },
        { id: 'personal', label: 'Personal Finance' },
        { id: 'sme', label: 'SME & Business' },
        { id: 'property', label: 'Loan Against Property' }
    ];

    const loanProducts = {
        housing: [
            { icon: '🏠', title: 'Home Loan', desc: 'Own your dream home with attractive rates', href: '/#home-loan' },
            { icon: '💸', title: 'Balance Transfer', desc: 'Transfer existing loan for better rates', href: '/#balance-transfer' },
            { icon: '➕', title: 'Top-Up Home Loan', desc: 'Extra funds on your existing home loan', href: '/#top-up' },
            { icon: '🏡', title: 'Loan Against Property', desc: 'Turn your assets into a financial ally', href: '/#lap-housing' }
        ],
        personal: [
            { icon: '⏱️', title: 'Personal Loan', desc: 'Collateral-free loan for all your needs', href: '/#personal-loan' },
            { icon: '🐷', title: 'Flexi Loan', desc: 'Flexible and hassle-free repayment', href: '/#flexi-loan' },
            { icon: '💸', title: 'Instant Personal Loan', desc: 'Quick funds when you need them', href: '/#instant-personal-loan' }
        ],
        sme: [
            { icon: '🔒', title: 'Secured Business Loan', desc: 'Competitive rates & flexible terms', href: '/#secured-business-loan' },
            { icon: '💳', title: 'Line Of Credit', desc: 'Anytime funds with quick approval', href: '/#line-of-credit' },
            { icon: '💼', title: 'Working Capital Loan', desc: 'Strengthen your business cash flow', href: '/#working-capital' },
            { icon: '🚚', title: 'Supply Chain Finance', desc: 'Quick access by discounting invoices', href: '/#supply-chain' },
            { icon: '🔓', title: 'Unsecured Business Loan', desc: 'Fast approval & flexible terms', href: '/#unsecured-business-loan' }
        ],
        property: [
            { icon: '🏡', title: 'Loan Against Property', desc: 'Unlock your property value', href: '/#lap' },
            { icon: '🏗️', title: 'Construction Finance', desc: 'Flexible funding for construction', href: '/#construction-finance' },
            { icon: '🏢', title: 'Commercial Property', desc: 'Flexible terms for property purchase', href: '/#commercial-property-purchase' },
            { icon: '🤝', title: 'Lease Rental Discounting', desc: 'Support for real estate businesses', href: '/#lease-rental-discounting' }
        ]
    };

    const currentProducts = loanProducts[activeTab] || [];

    return (
        <HeaderDropdown
            isOpen={isOpen}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            categories={categories}
            activeCategory={activeTab}
            onCategoryHover={setActiveTab}
            variant="wide"
        >
            <DropdownCardsGrid columns={currentProducts.length <= 3 ? currentProducts.length : 3}>
                {currentProducts.map((product, index) => (
                    <DropdownCard
                        key={index}
                        href={product.href}
                        icon={product.icon}
                        title={product.title}
                        description={product.desc}
                    />
                ))}
            </DropdownCardsGrid>
        </HeaderDropdown>
    );
};

export default LoansDropdown;
